<template>

    <div :class="{ 'page-list-container-blocked': isTutoActive }"
         class="page-list-container">

        <div class="page-content">

            <div class="card-container">

                <template v-for="(card, index) in list" v-if="card.show">

                    <transition name="accordion">

                        <div :class="{ selected: card.selected, 'card-invalid-grant': card.invalidGrant }"
                             class="card"
                             @click="toggleCard(index, card.email, card.invalidGrant)"
                             @mouseout="showByIndex = -1"
                             @mouseover="showByIndex = index">

                            <div class="card-content">

                                <div class="checkbox-container">
                                    <checkbox :checked="card.selected" :disabled="card.invalidGrant"></checkbox>
                                </div>

                                <div :class="{ 'invalid-grant': card.invalidGrant }"
                                     class="sender-container">

                                    <span class="sender-name ellipsis-text">{{ card.name | capitalizeFirstLetter }} </span>

                                    <span class="sender-from ellipsis-text">{{ card.sender }}</span>

                                    <mq-layout v-if="card.invalidGrant" :mq="['sm', 'md']"
                                               class="invalid-grant-text">{{ $t('cleaning_list_reconnect_mailbox') }}
                                    </mq-layout>

                                    <span v-if="card.error"
                                          class="card-action-error ellipsis-text">{{ $t('cleaning_list_text_error') }}</span>

                                </div>

                                <div :class="{ 'invalid-grant': card.invalidGrant }"
                                     class="card-infos-container">

                                    <div class="card-info-line">
                                        <img class="card-icon" src="/img/cards/mail-grey.svg">
                                        <span class="numbers card-icon-text">{{ card.count }}</span>
                                    </div>

                                    <div class="card-info-line">
                                        <img class="card-icon" src="/img/cards/eye-grey.svg">
                                        <span class="numbers card-icon-text">{{ card.openRate }}%</span>
                                    </div>

                                </div>

                                <div class="card-last-bloc"></div>
                            </div>

                        </div>

                    </transition>

                </template>

            </div>

            <div v-show="hasRowSelected" class="bottom-options-container">

                <div class="bottom-btn-white" @click="tagAction('auto-delete');unsubscribeSelected()">

                    <img class="bottom-btn-img-1" src="/img/icons/auto-delete-raspberry.svg">

                </div>

                <div class="bottom-btn-white bottom-btn-little" @click="tagAction('delete');deleteSelected()">

                    <img class="bottom-btn-img-2" src="/img/icons/trash-amina.svg">

                </div>

                <div class="bottom-btn-white" @click="tagAction('keep');keepSelected()">

                    <img class="bottom-btn-img-3" src="/img/icons/keep-green.svg">

                </div>

            </div>

        </div>

        <modal-tuto-keep ref="modalKeep"
                         @accept="closeModalKeep(true)"
                         @close="closeModalKeep(false)"
        ></modal-tuto-keep>

        <modal-tuto-delete ref="modalDelete"
                           @accept="closeModalDelete(true)"
                           @close="closeModalDelete(false)"
        ></modal-tuto-delete>

        <modal-tuto-unsubscribe ref="modalUnsubscribe"
                                @accept="closeModalUnsubscribe(true)"
                                @close="closeModalUnsubscribe(false)"
        ></modal-tuto-unsubscribe>

        <modal-rating ref="MR"
                      @close="closeRating"
        ></modal-rating>

        <tuto-list ref="tuto" @close="closeTuto"></tuto-list>

    </div>


</template>

<script>

import Vuex from 'vuex'

import Tag from '@/modules/tag'
import UserFlow from '@/modules/userFlow'

import Storage from '@/helpers/storage'

import Checkbox from '@/components/inputs/Checkbox'
import Markdown from '@/components/Markdown'
import LottieLoader from '@/components/lottie/LottieLoader'
import ModalRating from '@/components/modal/ModalRating'
import ModalTutoKeep from '@/components/modal/ModalTutoKeep'
import ModalTutoDelete from '@/components/modal/ModalTutoDelete'
import ModalTutoUnsubscribe from '@/components/modal/ModalTutoUnsubscribe'
import ModalDeleteAccount from '@/components/modal/ModalDeleteAccount'
import TutoList from '@/components/tuto/TutoList'
import Toast from '@/components/Toast'

export default {

    name: 'list',

    components: {
        Checkbox,
        Markdown,
        LottieLoader,
        ModalRating,
        ModalTutoKeep,
        ModalTutoDelete,
        ModalTutoUnsubscribe,
        ModalDeleteAccount,
        TutoList,
        Toast
    },

    props: {

        newsletters: {
            Type: Array,
            default: () => []
        },

        newslettersErrors: {
            Type: Array,
            default: () => []
        },

        tuto: {
            Type: Boolean,
            default: false
        }

    },

    watch: {

        tuto: function (bool) {

            if (bool) {

                this.$refs.tuto.start()

            }
        },

        newsletters: function () {

            this.updateList()

        },

        newslettersErrors: function () {

            this.updateList()

        }

    },

    data() {
        return {

            list: [],
            totalLength: 0,
            hasRowSelected: false,
            isTutoActive: false,
            actionStack: [],
            showByIndex: null,
            boolMyActionsTuto: false,
            rating: {
                actionCount: 0,
                shownAfter: 20,
                alreadyShown: false,
                opened: false,
                hasRated: false,
                displayCount: 0
            },
            firstTime: true
        }
    },

    computed: {

        nbSelected: function () {
            let counter = 0
            this.list.forEach(card => {
                if (card.selected && card.show) {
                    counter++
                }
            })
            return counter
        },

        updateProgress: function () {
            return `${Math.round(((this.totalLength - this.list.filter(card => card.show).length) * 100) / this.totalLength)}%`
        },

        untreated: function () {
            return this.totalLength - this.list.filter(card => card.show).length
        },

        isDesktop: function () {
            return this.$mq === 'lg'
        }

    },

    created() {

        UserFlow.setPage(this, 'cleaning_list')
    },

    mounted() {

        this.rating.alreadyShown = Storage.getItem('hasRated') === 'true'

        window.scrollTo(0, 0)

        this.updateList()

    },

    methods: {

        closeTuto() {
            this.isTutoActive = false
            Storage.setItem('needTutoList', false)
            this.bindCards()
        },

        keepSelected() {

            if (this.needConfirmKeep()) {
                const cards = this.getSelectedCards()
                this.$refs.modalKeep.open(cards)
            } else {
                this.requestKeep()
            }
        },

        deleteSelected() {

            if (this.needConfirmDelete()) {
                const cards = this.getSelectedCards()
                this.$refs.modalDelete.open(cards)
            } else {
                this.requestDelete()
            }
        },

        needConfirmKeep() {

            return !Storage.getItem('disableModalKeep')

        },

        needConfirmDelete() {

            return !Storage.getItem('disableModalDelete')

        },

        updateList() {

            const validArray = this.newsletters.slice().filter(item => !item.invalidGrant && !item.error)
            const newslettersErrors = this.newslettersErrors.slice() || []
            const invalidArray = this.newsletters.slice().filter(item => item.invalidGrant && !item.error)

            this.list = [...validArray, ...newslettersErrors, ...invalidArray]
            this.list.map(item => item.show = true)
            this.list.map(item => item.selected = false)

        },

        closeModalKeep(accept) {
            if (accept) {
                this.requestKeep()
            }
        },

        closeModalDelete(accept) {
            if (accept) {
                this.requestDelete()
            }
        },

        tagAction(action) {

            Tag.clickAll(this, action)

        },

        unsubscribeSelected(single) {

            if (this.needConfirmUnsubscribe()) {
                const cards = single || this.getSelectedCards()
                this.$refs.modalUnsubscribe.open(cards)
            } else {
                this.requestUnsubscribe()
            }
        },

        needConfirmUnsubscribe() {

            return !Storage.getItem('disableModalUnsubscribe')

        },

        closeModalUnsubscribe(accept) {

            if (accept) {
                this.requestUnsubscribe()
            }
        },

        bindCards() {

            // option bar
            let hasRowSelected = false
            this.list.forEach(card => {
                if (card.selected && card.show) {
                    hasRowSelected = true
                }
            })
            this.hasRowSelected = hasRowSelected

            // checkbox select all
            let bool = true
            this.list.forEach(card => {
                if (!card.selected && card.show) {
                    bool = false
                }
            })

        },

        toggleCard(index, email, invalidGrant) {

            if (invalidGrant) {

                this.$emit('invalidGrant', email)

            } else {

                const card = this.list[index]
                card.selected = !card.selected
                this.$set(this.list, index, card)

                if (this.isTutoActive) {
                    this.$refs.tuto.cardEventClick()
                }

                this.bindCards()

            }
        },

        requestDelete() {


            const arrayToTreat = this.getSelectedCards()

            this.updateRating(arrayToTreat.length)

            this.hasRowSelected = false

            this.$emit('requestDelete', arrayToTreat)

        },
        requestUnsubscribe() {


            const arrayToTreat = this.getSelectedCards()

            this.updateRating(arrayToTreat.length)

            this.hasRowSelected = false

            this.$emit('requestUnsubscribe', arrayToTreat)

        },

        requestKeep() {


            const arrayToTreat = this.getSelectedCards()

            this.updateRating(arrayToTreat.length)

            this.hasRowSelected = false

            this.$emit('requestKeep', arrayToTreat)


        },

        getSelectedCards() {
            return this.list
                .filter(card => card.selected && card.show)
        },

        goStats() {
            this.$router.push({path: '/stats'})
        },


        closeMyActionsTuto() {

            this.boolMyActionsTuto = false
            Storage.setItem('disableMyActionsTuto', true)
        },

        closeRating(rate) {
            Storage.setItem('hasRated', rate)
            this.rating.opened = false
            if (rate) {
                this.rating.alreadyShown = true
                Tag.clickAmplitude(this, 'rating')
                window.open('https://www.trustpilot.com/evaluate/www.cleanfox.io', '_blank', 'rel="noopener,noreferrer,nofollow"')
            }
        },

        updateRating(length) {

            this.rating.actionCount += length

            if (!this.rating.alreadyShown && this.rating.displayCount < 2) {
                if (!this.rating.opened) {
                    if (this.rating.actionCount >= this.rating.shownAfter) {
                        this.rating.displayCount += 1
                        this.rating.opened = true
                        this.rating.shownAfter = this.rating.actionCount + 40
                        this.$refs.MR.open()
                    }
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.page-list-container {
    background-color: $timberwolf;
    min-height: inherit;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    @media screen and (min-width: $above-tablet-length) {
        background-color: transparent;
        height: 100vh;
        overflow-y: hidden;
    }
}

.page-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;
    @media screen and (min-width: $above-tablet-length) {
        padding: 0 16px;
        display: flex;
        flex-direction: column;
        height: inherit;
    }
}

.page-list-container-blocked {
    height: 100vh;
    overflow: hidden;
    margin: 0;
}

.card-container {
    width: 100%;
    position: relative;
    margin-bottom: 100px;
    @media screen and (min-width: $above-tablet-length) {
        margin: 0;
        padding: 0 3px 200px;
        overflow-y: scroll;
        -ms-overflow-style: none; // IE 10+
        overflow: -moz-scrollbars-none; // Firefox
        scrollbar-width: none; // Firefox
        &::-webkit-scrollbar {
            display: none; // Safari and Chrome
        }
    }
}


.card {
    cursor: pointer;
    position: relative;
    height: 80px;
    background-color: $white;
    position: relative;
    @media screen and (min-width: $above-tablet-length) {
        transition: background-color 200ms ease;
        margin-bottom: 8px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        height: 88px;
        overflow: hidden;
    }
}

.card:hover {
    @media screen and (min-width: $above-tablet-length) {
        background-color: #F5F8FA;
    }
}

.card-invalid-grant {
    background-color: rgba(255, 255, 255, 0.5);
}

.card-light {
    background-color: $timberwolf;
    height: 60px;
    @media screen and (min-width: $above-tablet-length) {
        display: none;
    }
}

.card-content {
    display: flex;
    flex-direction: row;
    padding: 0 16px;
    @media screen and (min-width: $above-tablet-length) {
        padding: 0;
        height: inherit;
    }
}

.card-hover-container {
    position: absolute;
    right: 8px;
    top: 24px;
    display: flex;
    flex-direction: row;
    background-color: $white;
}

.bubble-hover {
    width: 40px;
    height: 40px;
    border-radius: 100px;
    background-color: #6d6f7b;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 24px;
    cursor: pointer;
}

.bubble-hover-delete {
    background-color: $blue;
}

.bubble-hover-keep {
    background-color: $green;
}

.bubble-hover-unsubscribe {
    background-color: $raspberry;
}

.bubble-hover-img {
    width: 20px;
    object-fit: contain;
}

.selected {
    background-color: $selected;
}

.selected:hover {
    background-color: #C7E3F5;
}

.checkbox-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 24px;
    margin-top: 16px;
    @media screen and (min-width: $above-tablet-length) {
        width: 88px;
        background-color: $timberwolf;
        margin-top: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.background-grey {
    background: $timberwolf;
}

.sender-container {
    display: flex;
    flex-direction: column;
    flex: 3;
    align-items: flex-start;
    width: 100%;
    padding-left: 16px;
    overflow: hidden;
    @media screen and (min-width: $above-tablet-length) {
        /*max-width: 426px;*/
    }
}

.card-infos-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 48px;
    margin-top: 8px;
    @media screen and (min-width: $above-tablet-length) {
        flex: 2;
        width: 100%;
        flex-direction: row;
        align-items: center;
        margin-top: 0;
        max-width: 322px;
        justify-content: space-between;
    }
}

.card-last-bloc {
    display: none;
    @media screen and (min-width: $above-tablet-length) {
        display: flex;
        flex: 1;
    }
}

.sender-name {
    font-size: 18px;
    font-weight: 500;
    margin-top: 14px;
    width: inherit;
    text-align: left;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 21px;
        margin-top: 21px;
    }
}

.sender-from {
    font-size: 14px;
    font-weight: 500;
    margin-top: 6px;
    width: inherit;
    text-align: left;
    color: $grey;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 16px;
        margin-top: 3px;
    }
}

.card-icon {
    width: 16px;
    object-fit: contain;
    @media screen and (min-width: $above-tablet-length) {
        width: 24px;
    }
}


.card-info-line {
    margin-top: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: $above-tablet-length) {
        margin: 0;
    }
}

.card-icon-text {
    font-size: 12px;
    margin-left: 8px;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 20px;
    }
}


.bottom-options-container {
    position: fixed;
    bottom: 74px;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 232px;
    justify-content: space-between;
    @media screen and (min-width: $above-tablet-length) {
        bottom: 24px;
    }
}

.bottom-btn-white {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 100%;
    background-color: $white;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
}

.bottom-btn-little {
    width: 56px;
    height: 56px;
}

.bottom-btn-img-1 {
    width: 32px;
    object-fit: contain;
}

.bottom-btn-img-2 {
    width: 28px;
    object-fit: contain;
}

.bottom-btn-img-3 {
    width: 36px;
    object-fit: contain;
}

.invalid-grant {
    opacity: 0.5;
}

.invalid-grant-text {
    font-size: 13px;
    font-weight: bold;
    color: $grey;
}

.card-action-error {
    font-size: 13px;
    font-weight: bold;
    color: $raspberry;
    text-align: left;
}


</style>
